import { render, staticRenderFns } from "./artist-block.vue?vue&type=template&id=1daef73d&scoped=true"
import script from "./artist-block.vue?vue&type=script&setup=true&lang=js"
export * from "./artist-block.vue?vue&type=script&setup=true&lang=js"
import style0 from "./artist-block.vue?vue&type=style&index=0&id=1daef73d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1daef73d",
  null
  
)

export default component.exports